import { GridCellProps } from '@progress/kendo-react-grid';
import { FC } from 'react';
import GridCellBase from 'src/components/GridCellBase';

const GLCodeMismatchField: FC<GridCellProps> = (props) => {
  const { hasGlMismatchItems } = props.dataItem;
  return (
    <GridCellBase
      {...props}
      rowSelectionEnabled={true}
      title={hasGlMismatchItems}
      style={{
        backgroundColor: hasGlMismatchItems === 'Y' ? '#EFB2B2' : '#C3D7B9',
        textAlign: 'center',
      }}
      className="overflow-auto"
    >
      <span>{hasGlMismatchItems}</span>
    </GridCellBase>
  );
};

export default GLCodeMismatchField;
